//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
let d=[[[0,"CaptureMethod",1,0],[0,"File",1,0],[0,"Format",1,0],[0,"ImageFile",1,0],[0,"Size",1,0]],[[["lengthOfRegionCorner","topLeftCorner","bottomRightCorner"],"GetRegion",{},0,0],[["topLeftCorner","bottomRightCorner"],"SetRegion",{},2,0]],[]];
SPLM.Gateway.ImageCaptureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.ImageCaptureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.ImageCaptureBuilder.CaptureMethodType = Object.freeze({
    "GraphicsArea" : "GraphicsArea", "Region" : "Region", "File" : "File", "Automatic" : "Automatic"});

SPLM.Gateway.ImageCaptureBuilder.ImageFormat = Object.freeze({
    "Bmp" : "Bmp", "Jpg" : "Jpg", "Gif" : "Gif", "Png" : "Png", "Tiff" : "Tiff"});

SPLM.Gateway.ImageCaptureBuilder.ImageSize = Object.freeze({
    "Pixels16" : "Pixels16", "Pixels24" : "Pixels24", "Pixels32" : "Pixels32", "Pixels48" : "Pixels48", "Pixels64" : "Pixels64", "Pixels96" : "Pixels96", "Pixels128" : "Pixels128"});

export default SPLM;